import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import HomePage from "./pages/Home_Page";
import LoginPage from "./pages/Login_Page";
import StudentPage from "./pages/Student_Page";
import CoursePage from "./pages/Course_Page";
import NotFoundPage from "./pages/NotFound_Page";
import SupervisorPage from "./pages/Supervisor_Page";
import AuthRequire from "./util/AuthRequire";
import AdminPage from "./pages/Admin_Page";
import { ToastContainer } from "react-toastify";
import CohortPage from "./pages/Cohort_Page";
import MajorPage from "./pages/Major_Page";
import CSVTOJSON from "./pages/CSV_TO_JSON";
import AttendPage from "./pages/attend/Attend_Page";
import MyStudentPage from "./pages/MyStudent_Page";
import AttendsPage from "./pages/attend/Attends_Page";
import GuidelinePage from "./pages/Guideline_Page";
import ReportPage from "./pages/Report_Page";
import CoursesetPage from "./pages/Courseset_Page";
import AttendShowPage from "./pages/attend/AttendShow_Page";
import CourseSchedule from "./pages/CourseSchedule_Page";
import Transcript_Page from "./pages/Transcript_Page";

function App() {
  const ROLES = {
    Student: process.env.REACT_APP_STL,
    Supervisor: process.env.REACT_APP_SUL,
    Admin: process.env.REACT_APP_AL,
  };
  const suffix = process.env.REACT_APP_SUFFIX_ROUTE;
  return (
    <BrowserRouter>
      <main>
        <ToastContainer position="top-center" />
        <Routes>
          {/* Public route  */}
          <Route path={`${suffix}/login`} element={<LoginPage />} />
          <Route path={`${suffix}/404`} element={<NotFoundPage />} />

          {/* Private route  */}
          <Route
            element={
              <AuthRequire
                allowedRoles={[ROLES.Student, ROLES.Supervisor, ROLES.Admin]}
              />
            }
          >
            <Route path={`${suffix}/`} element={<Layout />}>
              <Route
                element={
                  <AuthRequire
                    allowedRoles={[
                      ROLES.Student,
                      ROLES.Supervisor,
                      ROLES.Admin,
                    ]}
                  />
                }
              >
                <Route path="" element={<HomePage />} />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route path={`${suffix}/students`} element={<StudentPage />} />
              </Route>

              <Route
                element={<AuthRequire allowedRoles={[ROLES.Supervisor]} />}
              >
                <Route path={`${suffix}/attends`} element={<AttendsPage />} />
              </Route>

              <Route
                element={<AuthRequire allowedRoles={[ROLES.Supervisor]} />}
              >
                <Route
                  path={`${suffix}/attends/student`}
                  element={<AttendShowPage />}
                />
              </Route>
              
              <Route element={<AuthRequire allowedRoles={[ROLES.Supervisor]} />}>
                <Route path={`${suffix}/attends/student/transcript`} element={<Transcript_Page />} />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route path={`${suffix}/courses`} element={<CoursePage />} />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route
                  path={`${suffix}/course_set`}
                  element={<CoursesetPage />}
                />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route path={`${suffix}/cohorts`} element={<CohortPage />} />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route path={`${suffix}/majors`} element={<MajorPage />} />
              </Route>

              <Route element={<AuthRequire allowedRoles={[]} />}>
                <Route path={`${suffix}/csv`} element={<CSVTOJSON />} />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Student]} />}>
                <Route path={`${suffix}/attend`} element={<AttendPage />} />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route
                  path={`${suffix}/advisors`}
                  element={<SupervisorPage />}
                />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route path={`${suffix}/Admin`} element={<AdminPage />} />
              </Route>

              <Route
                element={
                  <AuthRequire
                    allowedRoles={[
                      ROLES.Admin,
                      ROLES.Student,
                      ROLES.Supervisor,
                    ]}
                  />
                }
              >
                <Route
                  path={`${suffix}/mystudents`}
                  element={<MyStudentPage />}
                />
              </Route>

              <Route
                element={
                  <AuthRequire
                    allowedRoles={[
                      ROLES.Admin,
                      ROLES.Student,
                      ROLES.Supervisor,
                    ]}
                  />
                }
              >
                <Route
                  path={`${suffix}/policies`}
                  element={<GuidelinePage />}
                />
              </Route>

              <Route element={<AuthRequire allowedRoles={[ROLES.Admin]} />}>
                <Route path={`${suffix}/report`} element={<ReportPage />} />
              </Route>

              {/* <Route element={<AuthRequire allowedRoles={[ROLES.Admin, ROLES.Supervisor, ROLES.Student]} />}> */}
              <Route
                element={
                  <AuthRequire
                    allowedRoles={[
                      ROLES.Admin,
                      ROLES.Supervisor,
                      ROLES.Student,
                    ]}
                  />
                }
              >
                <Route
                  path={`${suffix}/course_schedule`}
                  element={<CourseSchedule />}
                />
              </Route>
            </Route>
          </Route>
        </Routes>
      </main>
    </BrowserRouter>
  );
}

export default App;
